import { useEffect as useEffect } from 'react';
import { createCleanupCallback20ojlqmkr3oia as createCleanupCallback } from './internal/createCleanupCallback.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useEffect_0(dependencies, effect) {
  var callback = createCleanupCallback(effect);
  useEffect(callback, dependencies);
}
function useEffectOnce(effect) {
  var callback = createCleanupCallback(effect);
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  useEffect(callback, tmp$ret$0);
}
function useEffect_1(effect) {
  var callback = createCleanupCallback(effect);
  useEffect(callback);
}
//region block: exports
export {
  useEffectOnce as useEffectOnce3v2sm1lvkf783,
  useEffect_0 as useEffect2qxfqxq43a03l,
  useEffect_1 as useEffect3flx4wscmo2hh,
};
//endregion

//# sourceMappingURL=useEffect.mjs.map
